import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Our application gives you offline & online surveys, Supports iOS and Android Devices, Unlimited Responses, secure Cloud-Based Services. Our application gives you access to collect unlimited responses for a better understanding of your customers or employees. Measure customer loyalty by conducting an NPS survey ' },
      { name: 'author', content: 'CViewSurvey' },
      { 
        name: 'keywords',
        content: 'Data collect , Survey application , Collect data anywhere , NPS survey , Survey ' ,  },
    ]);

    this.setTitle('Conduct offline surveys anywhere | Collect data anywhere');
    // End SEO Meta Description

  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }

  
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
